var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PowerDataBase',{attrs:{"selectedLoops":_vm.selectedLoops,"real-data":_vm.realData,"options":_vm.options,"current-loop":_vm.currentLoop}})}
var staticRenderFns = []

export { render, staticRenderFns }